import { http } from '../http';
import { extrairMensagemErro } from '../../utils/apiError';

interface VeiculoCadastroResponse {
  mensagem: string;
  status: string;
  resposta_api: {
    mensagem: string;
    codigo_veiculo: number;
  };
}

interface RateioResponse {
  mensagem: string;
  valor_rateio_medio: string;
}

export interface EnviarParaSgaPorPlacaResponse {
  acao: string;
  placa: string;
  id: string;
  resultado: any;
}

export const cadastrarVeiculoSga = async (veiculoData: any, carroId: string): Promise<VeiculoCadastroResponse> => {
  try {
    const payload = { ...veiculoData, id: carroId };

    const response = await http.post('/sga-veiculo/cadastrar', payload);

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const buscarRateioSga = async (
  carroId: string,
  codigoRegional: string,
  valorFipe: string,
  codigoTipoVeiculo: string
): Promise<RateioResponse> => {
  try {
    const payload = {
      carroId,
      codigo_regional: codigoRegional,
      valor_fipe: valorFipe,
      codigo_tipo_veiculo: codigoTipoVeiculo,
    };

    const response = await http.post('/sga-veiculo/buscar-rateio', payload);

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao buscar o rateio médio");
  }
};

export const alterarSituacaoVeiculo = async (
  codigoSituacao: string,
  codigoVeiculo: string
): Promise<void> => {
  try {
    await http.post(
      `/sga-veiculo/alterar-situacao-para/${codigoSituacao}/${codigoVeiculo}`,
      {}
    );
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Erro ao alterar situação do veículo');
  }
};

const normalizePlaca = (placa: string) =>
  (placa ?? '').toString().trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

export const enviarVeiculoParaSgaPorPlaca = async (
  placa: string,
): Promise<EnviarParaSgaPorPlacaResponse> => {
  const placaNorm = normalizePlaca(placa);

  if (!placaNorm) {
    throw new Error('Placa é obrigatória.');
  }

  try {
    const response = await http.post(`/sga-veiculo/enviarParaSga/${placaNorm}`, {});

    return response.data as EnviarParaSgaPorPlacaResponse;
  } catch (error: unknown) {
    throw new Error(extrairMensagemErro(error, 'Erro ao enviar veículo para o SGA'));
  }
};
